import slate from '../../packages/plugins/content/slate';
import DraggablesAndLinks from './DraggablesAndLinks';
import { DraggablesModal } from './DraggablesModal';
const defaultSlate = slate();

const draggableContainerPlugin: any = (fn: any) => {
  return {
    Renderer: ({ children, data }: any) => {
      return (
        <div className="draggables-container-layout-outer">
          {/* {children} */}
          <DraggablesAndLinks
            elements={
              data && data.elements?.length > 0
                ? JSON.parse(data?.elements)
                : {
                    Blocks: [],
                    Lines: [],
                    Dots: [],
                    imageUrl: '',
                    AnchorsLinesColor: '#222',
                    ContainerHeight: '',
                  }
            }
          />
        </div>
      );
    },
    childConstraints: {
      maxChildren: 1,
    },

    id: 'draggables-container-layout-plugin',
    title: 'Draggables Editor',
    // description: 'emergency content plugin',
    version: 1,
    controls: [
      {
        title: 'Default Config',
        controls: {
          type: 'autoform',
          schema: {
            properties: {
              elements: {
                type: 'string',
                default: '',
                uniforms: {
                  component: DraggablesModal,
                  label: 'Elements Visualizer: ',
                  uploadImage: fn,
                },
              },
            },
          },
        },
      },
    ],
  };
};

export default draggableContainerPlugin;
